export default {"src":"/_next/static/media/popeyes-est-logo.b9e51038.svg","height":120,"width":120,"blurWidth":0,"blurHeight":0};